import { SUBSCRIPTION_SCREEN_ID } from 'constants/analytics';

import { changePathNameToScreenId } from 'services/Analytics/helpers';
import type { EventDataOverrides } from 'services/Analytics/core/Interfaces/Events';
import { ActionEventAction, ElementEventAction } from 'services/Analytics/core';

import { trackClick } from './mainTrackers';

export const sendAnalyticSideBarElementClick = (
    actionEvent: ActionEventAction,
    eventDataOverrides?: EventDataOverrides
) => {
    const screenId = changePathNameToScreenId();

    trackClick({
        elementEvent: ElementEventAction.button,
        actionEvent,
        isEventSchemaKey: screenId.includes(SUBSCRIPTION_SCREEN_ID),
        ...(eventDataOverrides && { eventDataOverrides }),
    });
};
